import React from "react"
import { MarketingAutomaticoContextProvider } from "./context/MarketingAutomaticoContextProvider"
import { MarketingAutomatico } from "./MarketingAutomatico"

export function Index() {
    return (
        <MarketingAutomaticoContextProvider>
            <MarketingAutomatico />
        </MarketingAutomaticoContextProvider>
    )
}
